import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "card-body py-2" }
const _hoisted_3 = { class: "form-row" }
const _hoisted_4 = { class: "col-lg-3 my-input-1" }
const _hoisted_5 = { class: "col-lg-3 date-input bold-label" }
const _hoisted_6 = { class: "col-lg-6 mt-3" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "col-lg-6 bold-label" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "card-header bg-light py-1" }
const _hoisted_15 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "badge badge-success ml-2" }
const _hoisted_18 = { class: "card-body py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DBEdit = _resolveComponent("DBEdit")!
  const _component_DBGrid = _resolveComponent("DBGrid")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DBForm = _resolveComponent("DBForm")!

  return (_openBlock(), _createBlock(_component_DBForm, {
    store: _ctx.store,
    config: _ctx.settings,
    data: _ctx.data,
    ref: "form"
  }, {
    default: _withCtx((form) => [
      _createVNode(_component_Card, {
        panelFun: _ctx.controller.panelFun.value,
        panel: _ctx.panel.key
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-header bg-light py-1" }, [
              _createElementVNode("h6", { class: "mb-0" }, [
                _createElementVNode("i", { class: "icon icon-file-text" }),
                _createTextVNode(" Накладная-требование ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "requirement_number",
                    readonly: ""
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "approval_date"
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (form.data?.status === 'requested' || form.data?.status === 'approved')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.issueRequirement && _ctx.issueRequirement(...args)), ["prevent"])),
                        class: "btn btn-primary",
                        title: "Отпустить товары"
                      }, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("i", { class: "icon icon-check" }, null, -1),
                        _createTextVNode(" Отпустить ", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "requested_by_id"
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "requested_mol_fio",
                    readonly: ""
                  }, null, 8, ["form"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "issued_by_id"
                  }, null, 8, ["form"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_DBEdit, {
                    form: form,
                    field: "issued_mol_fio",
                    readonly: ""
                  }, null, 8, ["form"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h6", _hoisted_16, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icon icon-list" }, null, -1)),
                  _cache[4] || (_cache[4] = _createTextVNode(" Наименование ТМЦ ", -1)),
                  _createElementVNode("span", _hoisted_17, "Позиций: " + _toDisplayString(_ctx.itemsCount), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_DBGrid, {
                form: form,
                field: "items",
                config: _ctx.itemsGridConfig,
                owner: form.data?.id,
                class: "invoice-requirement-items-grid",
                ref: "itemsGrid"
              }, null, 8, ["form", "config", "owner"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["panelFun", "panel"])
    ]),
    _: 1
  }, 8, ["store", "config", "data"]))
}